<template>
    <div class="form-page">
        <my-form readonly table>
            <el-form-item 
            class="table-full-row"
            label="招标项目名称">
                {{form.project_name}}
            </el-form-item>
            <my-form-item-group title="开标室信息">
                <el-form-item 
                class="table-full-row"
                label="开标室名称">
                    {{form.site_name}}
                </el-form-item>
                <el-form-item label="开始时间">
                    {{form.starttime}}
                </el-form-item>
                <el-form-item label="结束时间">
                    {{form.endtime}}
                </el-form-item>
            </my-form-item-group>
            <my-form-item-group title="评标室信息">
                <el-form-item 
                class="table-full-row"
                label="评标室名称">
                    {{form.site_name}}
                </el-form-item>
                <el-form-item label="开始时间">
                    {{form.starttime}}
                </el-form-item>
                <el-form-item label="结束时间">
                    {{form.endtime}}
                </el-form-item>
            </my-form-item-group>
            <my-form-item-group title="其他信息">
                <el-form-item 
                    label="选择标段"
                    class="table-full-row">
                        {{form.by3}}
                </el-form-item>    
                <el-form-item 
                    label="代理公司"  
                    class="table-full-row">
                        {{form.zbdl}}
                </el-form-item>        
                <el-form-item  label="联系人">
                    {{form.lxr}}
                </el-form-item>        
                <el-form-item  label="联系电话">
                    {{form.lxrtel}}
                </el-form-item>        
            </my-form-item-group>
            <template slot="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">关闭</el-button>
            </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
export default {
    mixins: [FORM_PAGE_MIXIN],
    data() {
        return{
            form:{
                
            },     
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        
        
    },
    created() {
        var that = this   
        
        that.jspInit(`${that.getGetters('ageUrl')}/bidding/hzbSite/init.json`, {
            zbprocode:that.getQuery('zbprocode'),
            guid:that.getQuery('guid'),
        }, data => {
            that.form = data.VSite;
            that.initialization = data;
        });
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">

</style>
